// extracted by mini-css-extract-plugin
module.exports = {"presence":"PresenceSection_presence__0GDEy","presence__col-left":"PresenceSection_presence__col-left__YRu1K","presence__col-right":"PresenceSection_presence__col-right__Flv6G"};